import { MenuEntry } from '@pancakeswap-libs/uikit'

const socials: MenuEntry[] = [
  {
    label: 'Home',
    icon: 'HomeIcon',
    href: '/',
  },
]

export default socials
